import { useEffect } from 'react';

const useBodyOverflow = (hidden: boolean = true) => {
  useEffect(() => {
    if (hidden) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [hidden]);
};

export default useBodyOverflow;
